// extracted by mini-css-extract-plugin
export default {"networkContainer":"GetInTouch_networkContainer__QA3zi","mainContainer":"GetInTouch_mainContainer__MKg5H"};